// Ported from prototype's `.tabs` / `.tab`. Active tab gets the accent
// underline; inactive tabs darken on hover.

interface Tab {
  id: string;
  label: string;
}

interface Props {
  tabs: Tab[];
  active: string;
  onChange: (id: string) => void;
}

export function Tabs({ tabs, active, onChange }: Props) {
  return (
    <div className="flex gap-0.5 border-b border-border mb-4">
      {tabs.map((t) => {
        const isActive = t.id === active;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            className={[
              'text-[13px] px-3 py-2.5 -mb-px border-b-2 transition-colors',
              isActive
                ? 'font-medium text-text border-accent'
                : 'font-medium text-text-2 hover:text-text border-transparent',
            ].join(' ')}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
